import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { companiesService } from '../../../services/companiesService';
import { CompanyShortDto } from '../../../models/companies/companyShortDto';

interface CompanyAutocompleteFormControlProps {
  name: string;
  label?: string;
  style?: React.CSSProperties;
  required?: boolean;
}

const CompanyAutocompleteFormControl: React.FC<CompanyAutocompleteFormControlProps> = ({ name, label = 'Клиент', style, required }) => {
  const { control } = useFormContext();
  const [companies, setCompanies] = useState<CompanyShortDto[]>([]);
  const [initialCompanies, setInitialCompanies] = useState<CompanyShortDto[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    companiesService.search({ name: '', page: 0, pageSize: 10 })
      .then(response => {
        setCompanies(response.data.data.items);
        setInitialCompanies(response.data.data.items);
      })
      .catch(error => {
        setCompanies([]);
        setInitialCompanies([]);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleInputChange = (_: React.SyntheticEvent, newInputValue: string) => {
    if (newInputValue.length >= 3) {
      setLoading(true);
      companiesService.search({ name: newInputValue, page: 0, pageSize: 10 })
        .then(response => {
          // Always use the search results, even if empty
          setCompanies(response.data.data.items);
        })
        .catch(() => setCompanies(initialCompanies))
        .finally(() => setLoading(false));
    } else {
      setCompanies(initialCompanies);
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required ? 'Обязательное поле' : false }}
      render={({ field, fieldState }) => (
        <Autocomplete
          options={companies}
          getOptionLabel={option => option.name}
          value={field.value}
          onChange={(_, value) => field.onChange(value)}
          onInputChange={handleInputChange}
          noOptionsText="Не найдено"
          isOptionEqualToValue={(option, value) => option.id === value.id}
          loading={loading}
          loadingText="Поиск..."
          renderInput={params => (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              margin="dense"
              size="small"
              style={style}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              placeholder="Введите от 3х букв"
              required={required}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      )}
    />
  );
};

export default CompanyAutocompleteFormControl; 